import React from "react";
import useForm from "../../../components/controls/useForm";
import QuizOptions from "./QuizOptions";

export default function QuizList({
  row,
  selectedOptions,
  handleOptionChange,
  handleSubmit,
}) {
  const {} = useForm();
  const { id, question, options } = row || {};
  let optionContent = null;
  if (options?.length > 0) {
    optionContent = options.map(
      (option, index) =>
        (optionContent = (
          <QuizOptions
            key={`${option?.id}_${index}`}
            quizId={id}
            option={option}
            selectedOptions={selectedOptions}
            handleOptionChange={handleOptionChange}
          />
        ))
    );
  }
  return (
    <>
      <div className="quiz">
        <h4 className="question">{question}</h4>
        <form onSubmit={handleSubmit} className="quizOptions">
          {optionContent}
        </form>
      </div>
    </>
  );
}
